import PropTypes from 'prop-types';
import React from 'react';

import BudgetLineItemsTableRow from './BudgetLineItemsTableRow';

const BudgetLineItemsTable = ({
  items,
  title,
  formatCurrency,
  numberWithCommas,
  totalRowTotal,
  children,
  totalRowRightHand,
  totalRowLeftHand,
  onClickAddSettlementLineItem,
  deleteSettlementLineItem,
  csrfToken,
  team,
  offer,
  itemToEdit,
  itemToEditChanged,
  leftHandTitle,
  rightHandTitle,
  totalTitle,
  deleteSettlementOverride,
  requestFormat,
  isSettling,
  isV3,
  tableColgroup,
  offerId,
  setBudgetState,
  editedDropCountChanged,
  showCurrencyConversion,
  globalCurrency,
  onToggleTaxWithholdingExemption
}) => (
  isSettling || items.length > 0 ? (
    <div style={{marginTop: "8px"}}>
      <table style={{"width": "100%", "borderSpacing": "0px 2px", "borderCollapse": "separate"}}>
        {tableColgroup}
        <thead style={{"textAlign": "left"}}>
          <tr style={{"background": "var(--od-c-f5f5f5, #F5F5F5)"}}>
            <th style={{
              "fontSize": "14px",
              "color": "var(--od-c-000000, #000000)",
              "padding": "6px 8px",
              "textAlign": "left"
            }}>
              <strong>{title}</strong>
            </th>
            {!isSettling && title === "Tickets" ? (
              <>
                <th style={{
                  "fontWeight": "600",
                  "fontSize": "14px",
                  "color": "var(--od-c-999999, #999999)",
                  "textAlign": "right",
                  "padding": "6px 9px 6px 0px"
                }}>
                  AVAIL
                </th>
                <th style={{
                  "fontWeight": "600",
                  "fontSize": "14px",
                  "color": "var(--od-c-999999, #999999)",
                  "textAlign": "right",
                  "padding": "6px 9px 6px 0px"
                }}>
                  COMPS
                </th>
                <th style={{
                  "fontWeight": "600",
                  "fontSize": "14px",
                  "color": "var(--od-c-999999, #999999)",
                  "textAlign": "right",
                  "padding": "6px 9px 6px 0px"
                }}>
                  KILLS
                </th>
              </>
            ) : null}
            <th style={{
              "fontWeight": "600",
              "fontSize": "14px",
              "color": "var(--od-c-999999, #999999)",
              "textAlign": "right",
              "padding": "6px 9px 6px 0px"
            }}>
              {rightHandTitle && rightHandTitle.length > 0 ? (
                rightHandTitle
              ) : (
                <span>&nbsp;</span>
              )}
            </th>
            <th style={{
              "fontWeight": "600",
              "fontSize": "14px",
              "color": "var(--od-c-999999, #999999)",
              "textAlign": "right",
              "padding": "6px 9px 6px 0px"
            }}>
              {leftHandTitle && leftHandTitle.length > 0 ? (
                leftHandTitle
              ) : (
                <span>&nbsp;</span>
              )}
            </th>
            {showCurrencyConversion ? (
              <th style={{
                "fontWeight": "600",
                "fontSize": "14px",
                "color": "var(--od-c-999999, #999999)",
                "textAlign": "right",
                "padding": "6px 9px 6px 0px"
              }}>
                {team.secondary_currency_symbol.toUpperCase()}
              </th>
            ) : null}
            <th style={{
              "fontWeight": "600",
              "fontSize": "14px",
              "color": "var(--od-c-999999, #999999)",
              "textAlign": "right",
              "padding": "6px 15px 6px 0px"
            }}>
              {totalTitle && totalTitle.length > 0 ? (
                totalTitle
              ) : (
                <span>&nbsp;</span>
              )}
            </th>
            <th style={{
              "padding": "6px 0px"
            }}>
              <span>&nbsp;</span>
            </th>
          </tr>
        </thead>
        <tbody style={{"fontSize": "14px"}}>
          {items.map((item, index) =>
            <BudgetLineItemsTableRow key={index}
                                      title={title}
                                      formatCurrency={formatCurrency}
                                      numberWithCommas={numberWithCommas}
                                      csrfToken={csrfToken}
                                      team={team}
                                      offer={offer}
                                      isSettling={isSettling}
                                      requestFormat={requestFormat}
                                      itemToEdit={itemToEdit}
                                      itemToEditChanged={itemToEditChanged}
                                      editedDropCountChanged={editedDropCountChanged}
                                      deleteSettlementLineItem={deleteSettlementLineItem}
                                      deleteSettlementOverride={deleteSettlementOverride}
                                      offerId={offerId}
                                      setBudgetState={setBudgetState}
                                      isV3={isV3}
                                      showCurrencyConversion={showCurrencyConversion}
                                      globalCurrency={globalCurrency}
                                      onToggleTaxWithholdingExemption={onToggleTaxWithholdingExemption}
                                      item={item} />
          )}
          <tr>
            <td style={{"paddingLeft": "8px"}}>
              {isSettling && requestFormat === "html" ? (
                <a href="#"
                    style={{
                      "textDecoration": "none",
                      "color": "var(--od-c-1982c4, #1982C4)",
                      "fontSize": "12px"
                    }}
                    onClick={
                      (e) => {
                        onClickAddSettlementLineItem(e);
                        editedDropCountChanged(null);
                      }
                    }>
                  <strong>
                    <i className="fas fa-plus-circle"
                        aria-hidden
                        style={{
                          "marginRight": "10px"
                        }}></i>
                    Add Item
                  </strong>
                </a>
              ) : (
                <span>&nbsp;</span>
              )}
            </td>
            {!isSettling && title === "Tickets" ? (
              <>
                <td
                  style={{
                    "textAlign": "right",
                    "fontSize": "14px",
                    "paddingRight": "9px"
                  }}>
                  <strong>
                    {items.reduce((sum, i) => { return sum + i.available }, 0).toLocaleString()}
                  </strong>
                </td>
                <td
                  style={{
                    "textAlign": "right",
                    "fontSize": "14px",
                    "paddingRight": "9px"
                  }}>
                  <strong>
                    {items.reduce((sum, i) => { return sum + i.comps }, 0).toLocaleString()}
                  </strong>
                </td>
                <td
                  style={{
                    "textAlign": "right",
                    "fontSize": "14px",
                    "paddingRight": "9px"
                  }}>
                  <strong>
                    {items.reduce((sum, i) => { return sum + i.kills }, 0).toLocaleString()}
                  </strong>
                </td>
              </>
            ) : null}
            <td style={{
                  "textAlign": "right",
                  "fontWeight": "bold",
                  "padding": "3px 9px 3px 0px",
                  "fontSize": "14px"
                }}>
              {totalRowRightHand && totalRowRightHand.length > 0 ? (
                totalRowRightHand
              ) : (
                <span>&nbsp;</span>
              )}
            </td>
            <td style={{"textAlign": "right", "paddingRight": "9px"}}>
              {totalRowLeftHand && totalRowLeftHand.length > 0 ? (
                <strong style={{"fontSize": "14px"}}>{totalRowLeftHand}</strong>
              ) : (
                <span>&nbsp;</span>
              )}
            </td>
            {showCurrencyConversion ? (
              <td style={{
                    "textAlign": "right",
                    "fontWeight": "bold",
                    "padding": "3px 9px 3px 0px",
                    "fontSize": "14px"
                  }}>
                {totalRowTotal ? (
                  globalCurrency.formatted(totalRowTotal)
                ) : (
                  <span>&nbsp;</span>
                )}
              </td>
            ) : null}
            <td style={{
                  "textAlign": "right",
                  "fontWeight": "bold",
                  "padding": "3px 15px 3px 0px",
                  "fontSize": "14px"
                }}>
              {totalRowTotal ? (
                formatCurrency(totalRowTotal)
              ) : (
                <span>&nbsp;</span>
              )}
            </td>
          </tr>
          {children ? (
            children
          ) : null}
        </tbody>
      </table>
    </div>
  ) : null
);

BudgetLineItemsTable.propTypes = {
  items: PropTypes.array,
  title: PropTypes.string.isRequired,
  formatCurrency: PropTypes.func.isRequired,
  numberWithCommas: PropTypes.func.isRequired,
  totalRowTotal: PropTypes.number,
  children: PropTypes.element,
  totalRowRightHand: PropTypes.string,
  totalRowLeftHand: PropTypes.string,
  onClickAddSettlementLineItem: PropTypes.func.isRequired,
  deleteSettlementLineItem: PropTypes.func.isRequired,
  csrfToken: PropTypes.string,
  team: PropTypes.object.isRequired,
  itemToEdit: PropTypes.object,
  itemToEditChanged: PropTypes.func.isRequired,
  leftHandTitle: PropTypes.string,
  rightHandTitle: PropTypes.string,
  totalTitle: PropTypes.string,
  deleteSettlementOverride: PropTypes.func.isRequired,
  isSettling: PropTypes.bool.isRequired,
  isV3: PropTypes.bool,
  onToggleTaxWithholdingExemption: PropTypes.func,
  requestFormat: PropTypes.string,
  tableColgroup: PropTypes.object.isRequired,
  offerId: PropTypes.string.isRequired,
  setBudgetState: PropTypes.func.isRequired,
  editedDropCountChanged: PropTypes.func.isRequired,
  showCurrencyConversion: PropTypes.bool,
  globalCurrency: PropTypes.object
};

export default BudgetLineItemsTable;
